// extracted by mini-css-extract-plugin
export default {"tableSection":"Historical_tableSection__gA421"};